import { Modal, Form } from 'react-bootstrap'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useActionFetch } from '@/utils/requests'
import LoadingButton from '@/components/shared/LoadingButton'
import { useToaster } from '@/components/shared/ToasterProvider'
import { apiContactUs } from '@/routes'

interface Props {
  show: boolean
  onClose?: () => void
}

interface FormValues {
  message: string
}

export default function ContactUsModal({ show, onClose }: Props) {
  const { register, handleSubmit, reset } = useForm<FormValues>()
  const [loading, setLoading] = useState<boolean>()
  const { actionFetch } = useActionFetch()
  const showToaster = useToaster()

  const onSubmit = async ({ message }: FormValues) => {
    setLoading(true)

    try {
      await actionFetch(apiContactUs.create(), {
        body: JSON.stringify({ message }),
      })

      reset()
      showToaster({ message: 'Message successfully sent' })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          Contact us
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)} className="d-flex flex-column gap-3">
          <Form.Group>
            <Form.Label>Message</Form.Label>
            <Form.Control
              as="textarea"
              type="text"
              placeholder="Enter you message why you are contacting us or just press send!"
              {...register('message')}
            />
          </Form.Group>
          <LoadingButton
            type="submit"
            loading={loading}
            text="Send email"
          />
        </Form>
      </Modal.Body>
    </Modal>
  )
}
